import { ChatMode, ChatState, FinalChunkData } from './chat/hooks/useChatMessages';

export const SIDEBAR_MODE = {
  standard: 'standard',
  expanded: 'expanded',
} as const;

export type SidebarMode = (typeof SIDEBAR_MODE)[keyof typeof SIDEBAR_MODE];

export type ContentMeta = {
  pageType: string;
  entityId?: string;
  metadata?: Record<string, string>;
  chatMode?: ChatMode;
  onChatStateChange?: (state: ChatState, data?: FinalChunkData) => void;
  getDocumentContent?: () => string;
};

export type SiestaMode = 'action' | 'chat' | 'busy';

export type SiestaAction = {
  id: string;
  label: string;
  prompt?: string;
};

export type AppContainerContextValue = {
  skipDefaultSidebar: boolean;
  sidebarContent: React.ReactNode | null;
  setSidebarContent: (content: React.ReactNode | null) => void;
  contentMeta: ContentMeta | null;
  setContentMeta: (meta: ContentMeta | null) => void;
  mode: SidebarMode;
  setMode: (mode: SidebarMode) => void;
  toggleMode: () => void;
  siestaMode: SiestaMode;
  setSiestaMode: (mode: SiestaMode) => void;
  siestaBusyGlowTop: number | null;
  setSiestaBusyGlowTop: (top: number | null) => void;
  conversationId: string;
};
